import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=896e0538&scoped=true"
import script from "./product-detail.vue?vue&type=script&lang=js"
export * from "./product-detail.vue?vue&type=script&lang=js"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=896e0538&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896e0538",
  null
  
)

export default component.exports